import { useEffect, useState } from "react";
import styled from "styled-components";
import { getAirbnb } from "../functions/getAirbnb";
import { Store } from "../interfaces/IStore";

const TD = styled.td`
  border-bottom: none;
`;

export const useAirbnb = (store: Store | undefined) => {
  const [starRating, setStarRating] = useState<number>();
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [storeHours, setStoreHours] = useState<{ [key: string]: any }[]>([]);
  const [storeAddress, setStoreAddress] = useState<string[]>();
  const [storeUrl, setStoreUrl] = useState<string>();
  const [googleDirectionsAPI, setGoogleDirectionsAPI] = useState<string>();
  const [airbnbData, setAirbnbData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    if (store?.airbnb_id && store.business_type === "airbnb") {
      getAirbnb({ id: store.airbnb_id.toString() }).then((data) => {
        setAirbnbData(data);
        setLoading(false);
      });
    } else {
      setAirbnbData(undefined);
    }
  }, [store]);

  useEffect(() => {
    store?.url && setStoreUrl(store.url);
    // First need to check to see if airbnb data is undefined.

    if (store?.airbnb_id) {
      getAirbnbInfo(Number(store.airbnb_id));
    } else {
      setStarRating(0);
      setPhoneNumber(undefined);
      setStoreHours([]);
      setStoreAddress(undefined);
      setStoreUrl(undefined);
      setGoogleDirectionsAPI(undefined);
    }
  }, [airbnbData]);

  const getAirbnbInfo = (id: number) => {
    setStarRating(store?.rating_override || airbnbData?.listing?.listing?.star_rating);
    setStoreAddress(airbnbData?.listing?.listing?.public_address.trim()); //googleData.formatted_address.split(",").map((a:string) => a.trim())
    !storeUrl && setStoreUrl(`https://www.airbnb.ca/rooms/${store?.airbnb_id}`);
  };

  return {
    loading,
    starRating,
    phoneNumber,
    storeHours,
    storeAddress,
    googleDirectionsAPI,
    storeUrl,
  };
};
